import React, { useState, useEffect } from 'react';
import { API_URL, fetchData } from '../helpers/api';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import TruncatableHtmlContent from '../utils/TruncatableHtmlContent';

const CollectionsPage = () => {
    const [collections, setCollections] = useState([]);
    const [selectedCollection, setSelectedCollection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [lightboxOpen, setLightboxOpen] = useState(false);

    useEffect(() => {
        const fetchCollections = async () => {
            try {
                const collectionsData = await fetchData(`/api/collections`, { populate: '*' });
                // Sort collections by their 'ordre' field
                const sortedCollections = collectionsData.sort((a, b) => a.order - b.order);
                setCollections(sortedCollections);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching collections:', error);
                setLoading(false);
            }
        };

        fetchCollections();
    }, []);

    if (loading) {
        return (
            <div className="container text-center py-5">
                <div className="spinner-border text-warning" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-5 mt-4">
            <h1 className="display-4 fw-bold mb-3 text-center">
                NOS <span className="text-warning">COLLECTIONS</span>
            </h1>

            <p className="text-center mb-5">
                L’exposition permanente est structurée autour d’une quarantaine d’îles ou modules didactiques regroupés en six archipels déclinant les temps forts de l’histoire longue de l’Esclavage allant de l’Antiquité à nos jours en passant par l’invention des Amériques, les ségrégations et les colonisations post-abolitionnistes. Découvrez une sélection des œuvres exposées et poursuivez votre visite dans nos murs.
            </p>

            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {collections.map((collection) => (
                    <div key={collection.id} className="col">
                        <div
                            className="card border-0 shadow h-100 hover-translate-up transition"
                            data-bs-toggle="modal"
                            data-bs-target="#collectionModal"
                            onClick={() => setSelectedCollection(collection)}
                        >
                            <div className="position-relative overflow-hidden rounded-top">
                                <img
                                    src={API_URL + collection.mainImage?.url}
                                    alt={collection.title}
                                    className="card-img-top object-fit-cover"
                                    style={{ height: "300px" }}
                                />
                                <div className="position-absolute bottom-0 start-0 end-0 bg-gradient-transparent-dark p-3">
                                    <h3 className="h4 text-white mb-0">{collection.title}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Collection Details Modal */}
            <div
                className="modal fade"
                id="collectionModal"
                tabIndex="-1"
                aria-labelledby="collectionModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl"> {/* Changed from modal-lg to modal-xl */}
                    <div className="modal-content">
                        {selectedCollection && (
                            <>
                                <div className="modal-header border-bottom-0">
                                    <h2
                                        className="modal-title fw-bold"
                                        id="collectionModalLabel"
                                    >
                                        {selectedCollection.title}
                                    </h2>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="row g-4">
                                        <div className="col-md-4">
                                            <img
                                                src={API_URL + selectedCollection.mainImage?.url}
                                                alt={selectedCollection.title}
                                                className="img-fluid rounded shadow cursor-pointer"
                                                onClick={() => setLightboxOpen(true)}
                                            />
                                        </div>
                                        <div className="col-md-8">
                                            <div className="description">
                                                <TruncatableHtmlContent
                                                    html={selectedCollection.description}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Lightbox for full-screen image viewing */}
            {lightboxOpen && selectedCollection && (
                <Lightbox
                    open={lightboxOpen}
                    close={() => setLightboxOpen(false)}
                    slides={[
                        {
                            src: API_URL + selectedCollection.mainImage?.url,
                            alt: selectedCollection.title
                        }
                    ]}
                    carousel={{
                        finite: true,        // Disables looping
                        preload: 0,          // Prevents preloading other images
                        showNavigation: false // Removes navigation arrows
                    }}
                />
            )}

            {/* Custom CSS for hover and transition effects */}
            <style jsx>{`
                .hover-translate-up {
                    transition: transform 0.3s ease;
                    cursor: pointer;
                }
                .hover-translate-up:hover {
                    transform: translateY(-10px);
                }
                .bg-gradient-transparent-dark {
                    background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
};

export default CollectionsPage;